<div class="content-container">
	<div class="content-container-header">
		@if (showRoleName) {
			<h3>
				{{ roleName }} |
				<b i18n="@@systemCapabilityTable-roleName">Capabilities</b>
			</h3>
		} @else {
			<h3>
				<b i18n="@@system-capabilityCapabilities">Capabilities</b>
			</h3>
		}
		@if (showSubtitle) {
			<p i18n="@@system-capabilityDefineMessage">Define what actions this role can take in relation to the company</p>
		}
	</div>

	<mat-divider></mat-divider>

	<div class="content-container-body column spacing-24">
		@for (displayItem of systemCapabilityDisplayItems; track displayItem.systemCapabilityItem.systemCapability.id) {
			@if (canDisplayCapability(displayItem.systemCapabilityItem.systemCapability.id)) {
				<div
					class="row capability-row"
					[attr.data-automation-id]="
						'system-capability-' + displayItem.systemCapabilityItem.systemCapability.name + '-row'
					"
				>
					<div class="column">
						<div class="row" style="column-gap: 8px">
							<h3>
								<b
									[attr.data-automation-id]="
										'system-capability-' + displayItem.systemCapabilityItem.systemCapability.name + '-title'
									"
									>{{ displayItem.displayName }}</b
								>
							</h3>
							<mat-chip-set>
								@if (displayItem.systemCapabilityItem.systemCapability.sentrilockOnly) {
									<mat-chip class="primary-chip chip-internal-color">
										<b i18n="@@system-capabilityINTERNAL">INTERNAL</b>
									</mat-chip>
								}
							</mat-chip-set>
						</div>
						<p
							[attr.data-automation-id]="
								'system-capability-' + displayItem.systemCapabilityItem.systemCapability.name + '-description'
							"
						>
							{{ displayItem.description }}
						</p>
					</div>
					<mat-button-toggle-group
						class="capability-toggle"
						[value]="displayItem.systemCapabilityItem.granted === true"
						[disabled]="isViewOnly || !canEditCapability(displayItem.systemCapabilityItem.systemCapability.id)"
						[hideSingleSelectionIndicator]="true"
					>
						<mat-button-toggle
							[value]="false"
							(change)="onCapabilityToggle(displayItem, $event.value)"
							i18n="@@system-capabilityNoToggle"
							data-automation-id="system-capability-no-toggle"
							>No
						</mat-button-toggle>
						<mat-button-toggle
							[value]="true"
							(change)="onCapabilityToggle(displayItem, $event.value)"
							i18n="@@system-capabilityYesToggle"
							data-automation-id="system-capability-yes-toggle"
							>Yes
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			}
		}
	</div>
</div>
